import AuthenticatedLayout from '@/components/layouts/AuthenticatedLayout';
import { ROUTES } from '@/constants/routes';
import { Route } from 'react-router-dom';
import Home from '@/pages/Home';
import ProfileDetails from '@/pages/profile/ProfileDetails';
import ProfileEdit from '@/pages/profile/ProfileEdit';
import CustomersListPage from '@/pages/customers/CustomersList';
import CustomersDetailsPage from '@/pages/customers/CustomersDetails';
import CustomersAddPage from '@/pages/customers/CustomersAdd';
import CustomersEditPage from '@/pages/customers/CustomersEdit';
import CustomersExternalAccountsListPage from '@/pages/customers/CustomersExternalAccounts';
import CustomersExternalAccountsAddPage from '@/pages/customers/CustomersExternalAccountsAdd';
import TeammatesListPage from '@/pages/teammates/TeammatesList';
import TeammateDetailPage from '@/pages/teammates/TeammateDetail';
import TeammateAddPage from '@/pages/teammates/TeammateAdd';
import TeammateEditPage from '@/pages/teammates/TeammateEdit';
import BusinessesListPage from '@/pages/businesses/BusinessesList';
import BankAccountsListPage from '@/pages/bankAccounts/BankAccountsList';
import BusinessDetailsPage from '@/pages/businesses/BusinessDetails';
import BusinessEditPage from '@/pages/businesses/BusinessEdit';
import BusinessAddPage from '@/pages/businesses/BusinessAdd';
import BankAccountsDetailsPage from '@/pages/bankAccounts/BankAccountsDetails';
import BankAccountsStatementsPage from '@/pages/bankAccounts/BankAccountsStatements';
import TransactionsListPage from '@/pages/transactions/TransactionsList';
import TransactionsDetailsPage from '@/pages/transactions/TransactionsDetails';
import BankAccountsTaxDocumentsPage from '@/pages/bankAccounts/BankAccountsTaxDocuments';
import WireRecipientsListPage from '@/pages/wireRecipients/WireRecipientsList';
import WireRecipientsAddPage from '@/pages/wireRecipients/WireRecipientsAdd';
import WireRecipientsDetailsPage from '@/pages/wireRecipients/WireRecipientsDetails';
import WireRequestsDetailsPage from '@/pages/wireRecipients/WireRequestsDetails';
import TransactionRequestListPage from '@/pages/transactionRequests/TransactionRequestList';
import TransactionRequestDetailsPage from '@/pages/transactionRequests/TransactionRequestDetails';
import BankAccountsEditPage from '@/pages/bankAccounts/BankAccountsEdit';
import ExternalAccountsListPage from '@/pages/externalAccounts/ExternalAccountsList';
import ExternalAccountsAddPage from '@/pages/externalAccounts/ExternalAccountsAdd';
import ExternalAccountsDetailsPage from '@/pages/externalAccounts/ExternalAccountsDetails';
import BankAccountApplicationPage from '@/pages/bankAccountApplications/BankAccountApplication';
import BankApplicationsDraftPage from '@/pages/bankAccountApplications/BankApplicationsDraft';
import BankApplicationsEsignPage from '@/pages/bankAccountApplications/BankApplicationsEsign';
import BankApplicationsSubmittedPage from '@/pages/bankAccountApplications/BankApplicationsSubmitted';
import BankApplicationsUnderReviewPage from '@/pages/bankAccountApplications/BankApplicationsUnderReview';
import BankApplicationsCompletedPage from '@/pages/bankAccountApplications/BankApplicationsCompleted';
import BankAccountApplicationDetailsPage from '@/pages/bankAccountApplications/BankAccountApplicationDetails';
import BankAccountEditApplicationPage from '@/pages/bankAccountApplications/BankAccountEditApplication';
import ScheduledTransactionsList from '@/pages/scheduledTransactions/ScheduledTransactionsList';
import ScheduledTransactionsDetails from '@/pages/scheduledTransactions/ScheduledTransactionsDetails';

export const AuthenticatedRoutes = (
  <Route element={<AuthenticatedLayout />}>
    <Route path={ROUTES.HOMEPAGE} element={<Home />} />
    <Route path={ROUTES.PROFILE} element={<ProfileDetails />} />
    <Route path={ROUTES.PROFILE_EDIT} element={<ProfileEdit />} />

    <Route path={ROUTES.CUSTOMERS} element={<CustomersListPage />} />
    <Route path={ROUTES.CUSTOMERS_DETAIL} element={<CustomersDetailsPage />} />
    <Route path={ROUTES.CUSTOMERS_ADD} element={<CustomersAddPage />} />
    <Route path={ROUTES.CUSTOMERS_EDIT} element={<CustomersEditPage />} />
    <Route
      path={ROUTES.CUSTOMERS_EXTERNAL_ACCOUNTS}
      element={<CustomersExternalAccountsListPage />}
    />
    <Route
      path={ROUTES.CUSTOMERS_EXTERNAL_ACCOUNTS_ADD}
      element={<CustomersExternalAccountsAddPage />}
    />

    <Route
      path={ROUTES.WIRE_RECIPIENTS_LIST}
      element={<WireRecipientsListPage />}
    />
    <Route
      path={ROUTES.WIRE_RECIPIENTS_DETAIL}
      element={<WireRecipientsDetailsPage />}
    />
    <Route
      path={ROUTES.WIRE_REQUESTS_DETAIL}
      element={<WireRequestsDetailsPage />}
    />
    <Route
      path={ROUTES.WIRE_RECIPIENTS_ADD}
      element={<WireRecipientsAddPage />}
    />

    <Route path={ROUTES.TEAMMATES} element={<TeammatesListPage />} />
    <Route path={ROUTES.TEAMMATES_DETAIL} element={<TeammateDetailPage />} />
    <Route path={ROUTES.TEAMMATES_ADD} element={<TeammateAddPage />} />
    <Route path={ROUTES.TEAMMATES_EDIT} element={<TeammateEditPage />} />

    <Route path={ROUTES.BUSINESSES} element={<BusinessesListPage />} />
    <Route path={ROUTES.BUSINESSES_DETAIL} element={<BusinessDetailsPage />} />
    <Route path={ROUTES.BUSINESSES_ADD} element={<BusinessAddPage />} />
    <Route path={ROUTES.BUSINESSES_EDIT} element={<BusinessEditPage />} />

    <Route path={ROUTES.BANK_ACCOUNTS} element={<BankAccountsListPage />} />
    <Route
      path={ROUTES.BANK_ACCOUNTS_DETAIL}
      element={<BankAccountsDetailsPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNTS_EDIT}
      element={<BankAccountsEditPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNTS_STATEMENTS_PARAMS}
      element={<BankAccountsStatementsPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNTS_TAX_DOCUMENTS_PARAMS}
      element={<BankAccountsTaxDocumentsPage />}
    />

    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS}
      element={<BankAccountApplicationPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATION_EDIT}
      element={<BankAccountEditApplicationPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATION_DETAILS}
      element={<BankAccountApplicationDetailsPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT}
      element={<BankApplicationsDraftPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_ESIGN}
      element={<BankApplicationsEsignPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_SUBMITTED}
      element={<BankApplicationsSubmittedPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW}
      element={<BankApplicationsUnderReviewPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_EXTERNAL_ACCOUNT_REVIEW}
      element={<BankApplicationsUnderReviewPage />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNT_APPLICATIONS_COMPLETED}
      element={<BankApplicationsCompletedPage />}
    />

    <Route
      path={ROUTES.EXTERNAL_ACCOUNTS}
      element={<ExternalAccountsListPage />}
    />
    <Route
      path={ROUTES.EXTERNAL_ACCOUNTS_ADD}
      element={<ExternalAccountsAddPage />}
    />
    <Route
      path={ROUTES.EXTERNAL_ACCOUNTS_DETAIL}
      element={<ExternalAccountsDetailsPage />}
    />

    <Route path={ROUTES.TRANSACTIONS_LIST} element={<TransactionsListPage />} />
    <Route
      path={ROUTES.TRANSACTIONS_DETAILS}
      element={<TransactionsDetailsPage />}
    />

    <Route
      path={ROUTES.TRANSACTION_REQUESTS_LIST}
      element={<TransactionRequestListPage />}
    />
    <Route
      path={ROUTES.TRANSACTIONS_REQUESTS_DETAILS}
      element={<TransactionRequestDetailsPage />}
    />

    <Route
      path={ROUTES.BANK_ACCOUNTS_SCHEDULED_TRANSACTIONS_PARAMS}
      element={<ScheduledTransactionsList />}
    />
    <Route
      path={ROUTES.BANK_ACCOUNTS_SCHEDULED_TRANSACTION_DETAILS_PARAMS}
      element={<ScheduledTransactionsDetails />}
    />
  </Route>
);
